import moment from 'moment';

var pto_func = {

    // check if input_day was saved in saas before
    is_input_date_taken(input_date, input_full_partial, pto_data, req_yr) {

        var cat_codes = this.getPtoCats("codes");
        var cat = "";
        var tmp = "";

        for (var i = 0; i < cat_codes.length; i++) {
            cat = cat_codes[i];
            if (!pto_data[req_yr][cat])
                continue;

            if (pto_data[req_yr][cat]['taken_dates_array']) {
                for (var j = 0; j < pto_data[req_yr][cat]['taken_dates_array'].length; j++) {
                    tmp = this.formatSaasDate(pto_data[req_yr][cat]['taken_dates_array'][j]);
                    if (tmp == input_date) {
                        // do not need to check is_sched_DIS(), saas data doesn't indicate if a taken PTO is DIS.
                        if (this.dayHasConflict(pto_data[req_yr][cat]['taken_full_partial_array'][j], input_full_partial)) {
                            return true;
                        }
                    }
                }
            }

            if (pto_data[req_yr][cat]['scheduled_dates_array']) {
                for (var k = 0; k < pto_data[req_yr][cat]['scheduled_dates_array'].length; k++) {
                    tmp = this.formatSaasDate(pto_data[req_yr][cat]['scheduled_dates_array'][k]);

                    if (tmp == input_date) {
                        if (this.is_sched_DIS(pto_data[req_yr][cat]['scheduled_full_partial_array'][k], pto_data[req_yr][cat]['scheduled_status_array'][k]))
                            return true; 
                        if (this.dayHasConflict(pto_data[req_yr][cat]['scheduled_full_partial_array'][k], input_full_partial))
                            return true;
                    }
                }
            }

        }
        return false;
    },

    dayHasConflict(day1, day2) {

        if (this.is_NYPFL(day1))
            return true;

        // compare day1 and day2 input_full_partial strings
        // for prenatal, input_full_partial is in format: "08:30 am_09:30 am"
        day1 = day1.toLowerCase();
        day2 = day2.toLowerCase();
        let full_partial_array = ["full", "am", "pm"];

        if (full_partial_array.includes(day1) && full_partial_array.includes(day2)) {    
            if (day1 == "full" || day2 == "full" || day1 == day2)
                return true;
            return false;
        } else { 
            
            // Do not need to check or validate for prenatal leave.
            // No easy way to accurately validate AM or PM conflicts.
            // As per Steve: Not everyone works 9-5. 
            return false ;

            /*
            // prenatal, at least one of the input is a time string
            if (day1 == "full" || day2 == "full")
                return true;

            // Do not need to check or validate for prenatal leave.
            // No easy way to accurately validate AM or PM conflicts.
            // As per Steve: Not everyone works 9-5. 
            /////return false ;

            //  Dec 3, 2024: Discussed how to check/validate prenatal request. Ended up deciding not to check/validate.
            //    Keeping notes on what was discussed, possible validation logic:
            //    1. Requests that start and end between 12:00 noon and 2:00 pm: do not validate.
            //    2. If a request has an end time before 2:00 pm, it's an AM request.
            //    3. If a request has a start time after 12:00 noon, it's a PM request.
            //    4. If a request has a start time before 12:00 noon and an end time after 2:00 pm, it's a full-day request.
            //    5. Then use that to check if it conflicts with any previous requests.
            
            let start1 = null;
            let end1 = null;
            let start2 = null;
            let end2 = null;
            let tmp = null;

            if (full_partial_array.includes(day1)) {
                //start1 = this.convert2Moment("start", day1) ;
                //end1 = this.convert2Moment("end", day1) ;
                // Not sure how to compare time against full/am/pm, leave it for now
                return false;
            } else {
                tmp = day1.split("_");
                start1 = moment(tmp[0], ['h:m a', 'H:m']) ;
                end1 = moment(tmp[1], ['h:m a', 'H:m']) ;
            }

            if (full_partial_array.includes(day2)) {
                //start2 = this.convert2Moment("start", day2) ;
                //end2 = this.convert2Moment("end", day2)
                // Not sure how to compare time against full/am/pm, leave it for now
                return false;                
            }else {
                tmp = day2.split("_");
                start2 = moment(tmp[0], ['h:m a', 'H:m']) ;
                end2 = moment(tmp[1], ['h:m a', 'H:m']) ;
            }

           return this.doRangesOverlap(start1, end1, start2, end2);
           
            */
        }
    },


    convert2Moment(type, full_partial_str) {

        // convert string to a moment obj
        var times = [{
            start: [{   full : "08:30 am" , am : "08:30 am", pm: "01:00 pm" }], 
            end: [{   full : "04:30 pm" , am : "12:30 pm", pm: "04:30 pm" }] 
            }] ;

        return moment(times[0][type][0][full_partial_str], ['h:m a', 'H:m']) ;

    },

    doRangesOverlap(start1, end1, start2, end2) {

        return start1.isBefore(end2) && start2.isBefore(end1);
    
    },


    update_pto_container(ori_sched, fy, pto_data, action) {

        // Mainly for PtoChange.vue.   
        // To return updated values to pto_container. Only scheduled days are tracked. 
        // pto_container contains run time requestes while editing and deleting requests.
        // Only properties that will be used in validateRequests() and is_input_date_taken() will be updated. 
        
        var ori = [];
        var ori_type = "";
        if (ori_sched.startsWith("jury_duty")) {
            ori_sched.replace("jury_duty", "juryduty");
            ori = ori_sched.split("_");
            ori_type = "jury_duty";    
        } else if (ori_sched.startsWith("covid_sick")) {
            ori_sched.replace("covid_sick", "covidsick");
            ori = ori_sched.split("_");
            ori_type = "covid_sick";    
        } else {
            ori = ori_sched.split("_");
            ori_type = ori[0];
        }

        //ori = ori_sched.split("_");
        //var ori_type = ori[0];
        var ori_date = ori[1];
        var ori_full_partial = ori[2];
        var day_num = 0.5;
        if (ori_type == "prenatal") {
            // format: prenatal_12/20/2024_09:00:00-10:00:00
            var tmp =  ori[2].split("-") ;
            var ori_start_time = moment(tmp[0], ['h:m a', 'H:m', 'HH:mm:ss']) ;
            var ori_end_time = moment(tmp[1], ['h:m a', 'H:m', 'HH:mm:ss']) ;
            day_num = ori_end_time.diff(ori_start_time, 'hours', true);
            //ori_full_partial = start_time.format('hh:mm a') + "_" + end_time.format('hh:mm a') ;
        } else {
            day_num = this.full_partial_to_num(ori_full_partial);
        }
        
        // New date conflicts with other scheduled days, put ori date back to scheduled array and decrement remain total.    
        if (action == "array_push") {
            pto_data[fy][ori_type]['scheduled_dates_array'].push(ori_date);
            pto_data[fy][ori_type]['remain_total'] -= day_num;
            if (ori_type == "prenatal") {
                pto_data[fy][ori_type]['scheduled_full_partial_array'].push("");
                pto_data[fy][ori_type]['scheduled_start_time_array'].push(ori_start_time.format("HH:mm:ss")) ;
                pto_data[fy][ori_type]['scheduled_end_time_array'].push(ori_end_time.format("HH:mm:ss"));
            } else {
                pto_data[fy][ori_type]['scheduled_full_partial_array'].push(ori_full_partial);
                pto_data[fy][ori_type]['scheduled_start_time_array'].push("") ;
                pto_data[fy][ori_type]['scheduled_end_time_array'].push("");
            }

           // pto_data[fy][ori_type]['scheduled_dates_array'].push(ori_date);
           // pto_data[fy][ori_type]['scheduled_full_partial_array'].push(ori_full_partial);
           // pto_data[fy][ori_type]['remain_total'] -= day_num;
           
        } else {
            for (var k = 0; k < pto_data[fy][ori_type]['scheduled_dates_array'].length; k++) {
                if (pto_data[fy][ori_type]['scheduled_dates_array'][k] == ori_date) {
                    if (    (ori_type == "prenatal" && 
                                pto_data[fy][ori_type]['scheduled_dates_array'][k] == ori_date &&
                                pto_data[fy][ori_type]['scheduled_start_time_array'][k] == ori_start_time.format("HH:mm:ss") &&
                                pto_data[fy][ori_type]['scheduled_end_time_array'][k] == ori_end_time.format("HH:mm:ss"))
                            ||                          
                            (ori_type != "prenatal" && 
                                pto_data[fy][ori_type]['scheduled_full_partial_array'][k] == ori_full_partial) 
                        ) {
                            pto_data[fy][ori_type]['scheduled_dates_array'].splice(k, 1);
                            pto_data[fy][ori_type]['scheduled_full_partial_array'].splice(k, 1);
                            pto_data[fy][ori_type]['remain_total'] += day_num;
                            pto_data[fy][ori_type]['scheduled_start_time_array'].splice(k, 1);
                            pto_data[fy][ori_type]['scheduled_end_time_array'].splice(k, 1);
                        } 
                }
                        
            }
        }
        return pto_data;
    },


    get_defaultRemaining(cat) {

        switch (cat) {
            case "bereavement":
                return 0;
            case "jury_duty":
                return 0;
            case "prenatal":
                return 20;
            case "covid":
                return 2;
            case "covid_sick":
                return 0;
            default:
                return 0;
        }

    },


    getPtoCats(type, gender = null) {

        var cur_fiscal_yr = this.get_fiscal_year("cur_long");
        var next_fiscal_yr = this.get_fiscal_year("next_long");
        var prev_fiscal_yr = this.get_fiscal_year("prev_long");

        var now_ny_dt = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
        var now = new Date(now_ny_dt);

        // Stop including covid sick from Aug 1, 2025
        var covid_sick_end_ny_dt = new Date('2025-07-31T11:00:00').toLocaleString('en-US', { timeZone: 'America/New_York' });
        var covid_sick_end_dt = new Date(covid_sick_end_ny_dt);
        var sick_plurals = "Sick Days" ;

        if (now <= covid_sick_end_dt)
            sick_plurals = "Sick Days (Non-COVID)" ;

        // 20 hours prenatal 

        var names = ["Vacation", "Sick", "Personal", "Floating Holiday", "COVID Vaccine/Booster", "COVID Sick Day", "Bereavement", "Jury Duty", "Prenatal Care"];
        var plurals = ["Vacation Days", sick_plurals, "Personal Days", "Floating Holidays", "COVID Vaccine/Booster", "COVID Sick Days", "Bereavement Days", "Jury Duty", "Prenatal Care"];
        var codes = ["vacation", "sick", "personal", "holiday", "covid", "covid_sick", "bereavement", "jury_duty", "prenatal"];
        var object_zero = {};
        
        // pto_mgr: names return by saas PTO.MGR.VIEW api
        var pto_mgr_mv = ["VACATION", "SICK", "PERSONAL", "HOLIDAY", "CVD", "COVID.SICK", "BEREAVE", "JD", "PRENATAL"];
        // categories that require approval:
        var pto_mgr_appr_mv = ["VACATION", "SICK", "PERSONAL", "HOLIDAY"];
        var pto_mgr_appr_codes =  ["vacation", "sick", "personal", "holiday"];
        var pto_mgr_date = ["VACATION", "SICK", "PERSONAL", "HOLIDAY", "COVID", "COVID.SICK", "BEREAVEMENT", "JURY.DUTY", "PRENATAL.DATE"];
        var pto_mgr_prefix = ["VAC", "SICK", "PER", "HOL", "COVID", "COVID.SICK", "BEREAVE", "JD", "PRENATAL"];
        var pto_mgr_limit = ["VacationLimit", "SickLimit", "PersonalLimit", "HolidayLimit"];
        var pto_mgr_carryOver = ["VacCarryOver", "SickCarryOver", "", ""];

        switch (type) {
            case "names":
                return names;
            case "plurals":
                return plurals;
            case "object_zero":
                object_zero[cur_fiscal_yr] = { vacation: 0, sick: 0, personal: 0, holiday: 0, covid: 0, covid_sick: 0, bereavement: 0, jury_duty: 0, prenatal: 0};
                object_zero[next_fiscal_yr] = { vacation: 0, sick: 0, personal: 0, holiday: 0, covid: 0, covid_sick: 0, bereavement: 0, jury_duty: 0,prenatal: 0};
                object_zero[prev_fiscal_yr] = { vacation: 0, sick: 0, personal: 0, holiday: 0, covid: 0, covid_sick: 0, bereavement: 0, jury_duty: 0, prenatal: 0};
                return object_zero;
            case "pto_mgr_mv":
                return pto_mgr_mv;
            case "pto_mgr_appr_mv":
                return pto_mgr_appr_mv;
            case "pto_mgr_appr_codes":
                return pto_mgr_appr_codes;
            case "pto_mgr_date":
                return pto_mgr_date;    
            case "pto_mgr_prefix":
                return pto_mgr_prefix;        
            case "pto_mgr_limit":
                return pto_mgr_limit;        
            case "pto_mgr_carryOver":
                return pto_mgr_carryOver;        
            case "object":
                var res = [];
 
               // Stop including covid vaccine after Dec 22, 2023
               var vaccine_end_ny_dt = new Date('2023-12-22T11:00:00').toLocaleString('en-US', { timeZone: 'America/New_York' });
               var vaccine_end_dt = new Date(vaccine_end_ny_dt);

                // Prenatal starts from Jan 1, 2025
                var prenatal_start_ny_dt = new Date('2025-01-01T11:00:00').toLocaleString('en-US', { timeZone: 'America/New_York' });
                var prenatal_start_dt = new Date(prenatal_start_ny_dt);

              
                for (var i = 0; i < codes.length; i++) {
                    if (codes[i] == "covid" && now > vaccine_end_dt) {  
                        continue;
                    } else if (codes[i] == "covid_sick" && now > covid_sick_end_dt) {
                        continue;
                    } else if (codes[i] == "prenatal" && (now < prenatal_start_dt || (now >= prenatal_start_dt && gender != 'F'))) {
                        continue;                        
                    } else {
                        res.push({ id: codes[i], name: plurals[i] });
                    }
                }
                return res;
            default:
                return codes;
        }
    },


    get_today_date() {
        // hardcoded today for testing purpouse
        //return new Date("2023-08-02T01:00:00");
        //window.console.log(new Date());
        var timestamp = new Date().setUTCHours(9,0,0,0);
        var res = new Date(timestamp);
        //res = new Date("2023-08-02T01:00:00");
        return res;
    },

    
    get_date_picker_min() {

        var res = this.get_today_date();
        var site_status = this.get_site_status();

        var fy_start_month = 9;
        if (this.debug()) {
            fy_start_month = this.debug_fy_start_month();
        }
        /* ***** DO NOT REMOVE *****
        var app_mode = this.app_mode();
        // when first launch, do not allow making request < 2021-09-01
        if (app_mode == "limited_live") {
            var last_month = this.get_today_date();
            last_month.setDate(1);
            last_month.setMonth(last_month.getMonth() - 2);
            var default_min = new Date("2022-09-01T09:00:00.000Z");
    
            if (last_month.getTime() < default_min.getTime())
                res = default_min;
            else
                res = last_month;
        } else {
            res.setDate(1);
            res.setMonth(res.getMonth() - 1);
        }
        */
       // Set date picker min to two months before current month
        res.setDate(1);

        if (site_status == "cur_year_only") {
            // In general, retro requests can be submitted up to 4 months back. 
            // However, from September to January, once the data is rolled, requests cannot be submitted for the previous fiscal year.
            var today = this.get_today_date();
            var today_month = (today.getMonth() + 1); 

            // Establish the "September Floor" (0-indexed for JS Date: 8 = Sept)
            var septFloor = fy_start_month - 1; 

            // Determine the maximum allowed rollback month (4 months back from current)
            var maxRollbackMonth = res.getMonth() - 4;

            // Apply the logic based on where we are in the Fiscal Year
            if (today_month >= fy_start_month && today_month <= 12) {
                // Sept - Dec: Can go back, but absolutely cannot cross the Sept floor
                if (maxRollbackMonth < septFloor) {
                    res.setMonth(septFloor);
                } else {
                    res.setMonth(maxRollbackMonth);
                }
            } else {
                // Jan - Aug: Pure rolling 4 months back (e.g., June rolls back to February)
                res.setMonth(maxRollbackMonth);
            }
        /*    
        } else if (site_status == "after_data_rolled") {    
            if ((res.getMonth() + 1) == fy_start_month) {
                // if month == 9, do not set datepicker min to Aug, user cannot change prev year's pto, just do nothing
            } else {
                // if month != 9, set datepicker min to last month
                res.setMonth(res.getMonth() - 1);
            }
        } else if (site_status != "roll_data") {    
            // cur_and_next_year, prev_and_cur_year
            // can make request for prev month
            res.setMonth(res.getMonth() - 1);
            */
        } else {
            // cur_and_next_year, prev_and_cur_year
            // can make request four months back
            res.setMonth(res.getMonth() - 4);
        }

        res = res.toLocaleString("en-us", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            timeZone: "UTC"
        }).replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");

        return res;

    },


    get_date_picker_max() {
        /* ***** DO NOT DELETE *****
        var app_mode = this.app_mode();
        if (app_mode == "pilot") {
            return "2023-08-31";
        } else if (app_mode == "limited_live") {
            //return "2022-08-31";
            return "2023-08-31";
        } else { // use max au_holidays to calculate max date, Steve manages au_holidays
            var last_holiday = au_holidays[au_holidays.length - 1];
            var last = new Date(last_holiday + "T09:00:00.000Z");
            return last.getFullYear() + "-08-31";
        }
        */
        var default_end_year = this.get_default("date_picker_end_year") ;
        return default_end_year + "-08-31";
        
    },


    app_mode() {
        //return "pilot";
        //return "limited_live"; // when first launch, live site won't support following year request
        return ""; // full features, probably do not need this function anymore
    },


    //////////////////
    // Site Status:
    // cur_year_only:       Can manage pto for cur year only.
    // cur_and_next_year:   Can manage pto for cur and next fiscal year
    // prev_and_cur_year:   Can manage pto for prev and cur year. Usually from Sept 1 to before hard freeze begin.
    // -------- Status below are not being used anymore -------- 
    // roll_data:           SAAS roll data. Can view prev year in balance tab but cannot make changes. Can manage pto for cur year.
    // after_data_rolled:   HR wants to show prev year tab PTO until Nov 1. No changes can be made for prev year.
    // transition_rough:    Early Sept, HR is getting ready to roll data. Only accepts retro requests for Aug (previous month). 
    //                      Shows a popup on request page, Manager tab is still available.
    // saas_locked:         HR roll data. Can't do anything (no new request, can't edit, confirm, approve, anything.... No Managers tab). 
    //                      PTO site shows a " During our PTO reconciliation process.... " message 
    //////////////////
    get_site_status() {

        // for cur_and_next_year status
        // if SAAS sends a flag, change the code to check that flag
        var cur_and_next_year_start_date = "2026-05-18"; 
        var cur_and_next_year_end_date = "2026-08-31"; 

        // for prev_and_cur_year status
        // if SAAS sends a flag, change the code to check that flag
        var prev_and_cur_year_start_date = "2026-09-01"; 
        // * "prev_and_cur_year_end_date" would be the day users stop having access to prev year features.
        //     Usually it's the day before pto data roll in Sept.
        // * Ask HR for the date in the first week of Sept.
        // * If you do not have the date: set prev_and_cur_year_end_date to Sept 30. Data roll will happen before end of Sept. 
        // * Setting "prev_and_cur_year_end_date" to the day before data roll would set site_status to "cur_year_only", 
        //     so users cannot access prev year features.
        var prev_and_cur_year_end_date = "2026-09-14"; // the day before data roll

        //var roll_data_start_date = "2023-09-20"; 
        //var roll_data_end_date = "2023-09-25"; 
        //var cur_year_only_start_date = "2023-09-20";

        // transition_rough: begins in Sept 1, can only add retro requests for Aug and show a popup on request page
        // If we are not doing transition_rough, set date in the past
        //var transition_rough_start_date = "2022-09-01"; 
        //var transition_rough_end_date = "2022-09-16"; 

        // Shutdown entire site for saas to roll data, can't do anything.
        //var saas_locked_start_date = "2022-09-01"; 
        //var saas_locked_end_date = "2022-09-16"; 

        ////////// testing begin //////////
        
        if (this.debug()) {
            cur_and_next_year_start_date = "2023-05-01"; 
            cur_and_next_year_end_date = "2023-08-28"; 

            prev_and_cur_year_start_date = "2023-08-29"; 
            prev_and_cur_year_end_date = "2023-09-05"; 

            //roll_data_start_date = "2023-09-07";
            //roll_data_end_date = "2023-09-12";
            //cur_year_only_start_date = "2023-09-06";

        }
        ////////// testing end //////////

        //////////
        var today = this.get_today_date();
        var cur_and_next_year_start = new Date(cur_and_next_year_start_date + "T09:00:00.000Z");
        var cur_and_next_year_end = new Date(cur_and_next_year_end_date + "T09:00:00.000Z");

        var prev_and_cur_year_start = new Date(prev_and_cur_year_start_date + "T09:00:00.000Z");
        var prev_and_cur_year_end = new Date(prev_and_cur_year_end_date + "T09:00:00.000Z");

        /* These status are not needed anymore
        //var roll_data_start = new Date(roll_data_start_date + "T09:00:00.000Z");
        //var roll_data_end = new Date(roll_data_end_date + "T09:00:00.000Z");        

        //var cur_year_only_start = new Date(cur_year_only_start_date + "T09:00:00.000Z"); 
        
        //var transition_rough_start = new Date(transition_rough_start_date + "T09:00:00.000Z");
        //var transition_rough_end = new Date(transition_rough_end_date + "T09:00:00.000Z");

        //var saas_locked_start = new Date(saas_locked_start_date + "T09:00:00.000Z");
        //var saas_locked_end = new Date(saas_locked_end_date + "T09:00:00.000Z");
  
        //if (today >= saas_locked_start && today <= saas_locked_end) 
        //    return "saas_locked";
        //else if (today >= transition_rough_start && today <= transition_rough_end)
        //    return "transition_rough";
        //else if (today >= prev_and_cur_year_start && today <= prev_and_cur_year_end)
        */

        if (today >= prev_and_cur_year_start && today <= prev_and_cur_year_end)
            return "prev_and_cur_year";
        else if (today >= cur_and_next_year_start && today <= cur_and_next_year_end)
            return "cur_and_next_year";
        //else if (today >= roll_data_start && today <= roll_data_end)
        //    return "roll_data";
        //else if (today > roll_data_end && today < cur_year_only_start)
        //    return "after_data_rolled";
        else
            return "cur_year_only";
    },


    get_fiscal_year(which, date = null) {

        var fy_start_month = 9;
        if (this.debug()) {
            fy_start_month = this.debug_fy_start_month();
        }

        var today = this.get_today_date();  // date object
        var calendar_cur_month = (today.getMonth() + 1) ; // getMonth() returns 0 - 11
        var calendar_cur_year_num = today.getFullYear();
        var calendar_next_year_num = null;
        var calendar_prev_year_num = null;
        var calendar_cur_year_str = null;
        var calendar_next_year_str = null;
        var calendar_prev_year_str = null;
        var calendar_cur_year_str_short = null;
        var calendar_next_year_str_short = null;
        //var calendar_prev_year_str_short = null;
        var res = null;

        calendar_next_year_num = (calendar_cur_year_num + 1);
        calendar_prev_year_num = (calendar_cur_year_num - 1);

        calendar_cur_year_str = calendar_cur_year_num.toString();
        calendar_next_year_str = calendar_next_year_num.toString();
        calendar_prev_year_str = calendar_prev_year_num.toString();

        calendar_cur_year_str_short = calendar_cur_year_str.substring(calendar_cur_year_str.length - 2);
        calendar_next_year_str_short = calendar_next_year_str.substring(calendar_next_year_str.length - 2);
        //calendar_prev_year_str_short = calendar_prev_year_str.substring(calendar_prev_year_str.length - 2);

        switch (which) {

            case "cur":
            case "cur_long":
                if ( (calendar_cur_month >= fy_start_month && calendar_cur_month <= 12) ) 
                    res = calendar_cur_year_str;
                else 
                    res = calendar_prev_year_str;
                break;

            case "cur_str":
                res = "Fiscal Year ";
                if ( (calendar_cur_month >= fy_start_month && calendar_cur_month <= 12) ) 
                    res +=  calendar_cur_year_str + "-" + calendar_next_year_str_short ;
                else 
                    res += calendar_prev_year_str + "-" + calendar_cur_year_str_short ;
                break;

            case "cur_str_short":
            case "next_str_short":
            case "prev_str_short":
                res = "FY ";
                if (which == "next_str_short") {
                    res +=  calendar_cur_year_str + "-" + calendar_next_year_str_short ;
                } else if (which == "prev_str_short") {
                    res +=  calendar_prev_year_str + "-" + calendar_cur_year_str_short ; 
                } else {
                    if ( (calendar_cur_month >= fy_start_month && calendar_cur_month <= 12) ) 
                        res += calendar_cur_year_str + "-" + calendar_next_year_str_short ;
                    else 
                        res += calendar_prev_year_str + "-" + calendar_cur_year_str_short ;
                }
                break;
    
                        
            case "next":
            case "next_long":
                if ( (calendar_cur_month < fy_start_month && calendar_cur_month <= 12) ) 
                    res = calendar_cur_year_str;
                else 
                    res = calendar_next_year_str;
                break;    

            case "prev":
            case "prev_long":
                if ( (calendar_cur_month < fy_start_month && calendar_cur_month <= 12) ) {
                    // Jan ~ Aug: calendar year = 23, current fy = 22 (i.e. prev year), prev fy = 21 (prev year - 1) 
                    var calendar_prev_year_minus_one_num = (calendar_prev_year_num - 1);
                    res = calendar_prev_year_minus_one_num.toString(); 
                } else {
                    // Sept ~ Dec: calendar year = 23, current fy = 23, prev fy = 22 
                    res = calendar_prev_year_str;
                }
                break;                 

            case "next_str":
                res = "Fiscal Year ";
                res +=  calendar_cur_year_str + "-" + calendar_next_year_str_short ;
                break;

            case "prev_str":
                res = "Fiscal Year ";
                res +=  calendar_prev_year_str + "-" + calendar_cur_year_str ;
                break;

            case "date_long":
            case "saas_date":    
                if (date == null)
                    return 0;
                if (which == "saas_date") {
                    let tmp_d = date.split("/");
                    let tmp_date = new Date(tmp_d[2] + "-" + tmp_d[0] + "-" + tmp_d[1] +  "T09:00:00.000Z");
                    date = tmp_date;
                }                    
                var month = (date.getMonth() + 1) ; // getMonth() returns 0 - 11
                var year = date.getFullYear();
    
                if ( (month >= fy_start_month && month <= 12) ) 
                    res = year;
                else 
                    res = (year - 1);

                //window.console.log("date_long: " + date + ", month=" + month + ", fy_start_month=" + fy_start_month + ", year=" + year);

                break;
        }    

        return res;
    },


    get_fy_str(which, args) {

        let res = "";
        // current site_status: cur_year_only, cur_and_next_year, prev_and_cur_year, roll_data, after_data_rolled
        switch(which) {
            case "alert":
                if (args['site_status'] == "cur_year_only") {
                    res = "";
                } else {
                    res = " in Fiscal Year ";
                    if (args['req_yr'] == args['cur_fiscal_year']) {
                        res += args['cur_fiscal_year'] + "-" + args['next_fiscal_year'];
                    } else if (args['req_yr'] == args['next_fiscal_year']) {
                        let next_yr_plus_one = (Number(args['next_fiscal_year']) + 1).toString();
                        res += args['next_fiscal_year'] + "-" + next_yr_plus_one;
                    } else if (args['req_yr'] == args['prev_fiscal_year']) {
                        let prev_yr_plus_one = (Number(args['prev_fiscal_year']) + 1).toString();
                        res += args['prev_fiscal_year'] + "-" + prev_yr_plus_one;
                    }
                }
                break;

        }

        return res;

    } ,   


    get_default(type) {

        var fy_start_month = 9;
        if (this.debug()) {
            fy_start_month = this.debug_fy_start_month();
        }

        switch(type) {

            case "default_end_year":
            case "default_start_year":
            case "date_picker_end_year":

                var today = this.get_today_date();  // date object
                var cur_month = (today.getMonth() + 1) ; // getMonth() returns 0 - 11
                var cur_year = today.getFullYear();
                var start_year = null;
                var end_year = null;

                if (type == "date_picker_end_year") {
                    var site_status = this.get_site_status() ;
                    if ( (cur_month >= fy_start_month && cur_month <= 12) ) {
                        return (cur_year + 1) ;
                    } else {        // (cur_month >= 1 && cur_month <= 8)
                        if (site_status == "cur_and_next_year")
                            return (cur_year + 1);
                        else
                            return cur_year;
                    }
                }

                if ( (cur_month >= fy_start_month && cur_month <= 12) ) {
                    start_year = cur_year;
                    end_year = (cur_year + 1) ;
                } else { 
                    start_year = (cur_year - 1);
                    end_year = cur_year;
                }

                if (type == "default_start_year")
                    return start_year
                if (type == "default_end_year")
                    return end_year;
                break;

        }

    },


    formatNum(input) {
        if (Number.isNaN(Number.parseFloat(input))) {
            return 0;
        }
        return parseFloat(input);
    },


    formatAuHolidays(saas_data) {

        var src_holidays = saas_data.split("|");
        var res = [];
        if (Array.isArray(src_holidays)) {
            for (let i = 0; i < src_holidays.length; i++) {
                if (src_holidays[i].length > 0) {
                    res.push(this.formatDate(new Date(this.formatSaasDate(src_holidays[i]) + "T09:00:00.000Z")));
                }
            }
        }
        return res;

    },

/*
    formatEmpPto(saas_data, pto, pto_cat_codes, pto_cat_names, pto_cat_plurals) {

        var tmp = "";
        var taken_scheduled = [];
        var prefix = "";

        if (saas_data['lastname'].toUpperCase() == "SHING" || saas_data['lastname'].toUpperCase() == "IAFRATE" || 
            (saas_data['lastname'].toUpperCase() == "HAYES" && saas_data['firstname'].toUpperCase() == "JONI")) {
            pto['lastname'] = this.maskEmpName(saas_data['lastname']);
            pto['firstname'] = this.maskEmpName(saas_data['firstname']);    
        } else {
            pto['lastname'] = saas_data['lastname'];
            pto['firstname'] =saas_data['firstname'];
        }

        //pto['lastname'] = this.maskEmpName(saas_data['lastname']);
        //pto['firstname'] = this.maskEmpName(saas_data['firstname']);

        for (var i = 0; i < pto_cat_codes.length; i++) {
            tmp = pto_cat_codes[i];

            if (typeof saas_data[tmp] == 'undefined')
                continue;

            if (
                tmp == "vacation" ||
                tmp == "sick" ||
                tmp == "personal" ||
                tmp == "holiday"
            ) {
                prefix = tmp;
                if (tmp == "vacation") prefix = "vac";
                else if (tmp == "personal") prefix = "per";
                else if (tmp == "holiday") prefix = "hol";
                pto[tmp]["limit"] = this.formatNum(saas_data[prefix + "_limit"]);
                pto[tmp]["remain"] = this.formatNum(saas_data[prefix + "_rem"]);
                pto[tmp]["accrued"] = this.formatNum(saas_data[prefix + "_accrued"]);
                pto[tmp]["carr_over"] = this.formatNum(saas_data[prefix + "_co"]);
                pto[tmp]["carr_over_remain"] = this.formatNum(saas_data[prefix + "_co_rem"]);
            } else { 
                // special categories has taken or requested dates
                pto[tmp]["limit"] = pto_func.get_defaultRemaining(tmp);
                pto[tmp]["carr_over"] = 0;
            }
            pto[tmp]["name"] = pto_cat_names[i];
            pto[tmp]["name_plural"] = pto_cat_plurals[i];
            pto[tmp]["name_code"] = pto_cat_codes[i];
            pto[tmp]["requested"] = saas_data[tmp];

            taken_scheduled = this.taken_scheduled_dates(pto[tmp]["requested"], tmp, pto[tmp]["name_code"]);

            // SAAS data is in ascending order. Reverse to descending order
            pto[tmp]["taken_info_array"] = taken_scheduled["taken_info_array"].slice().reverse();
            pto[tmp]["taken_status_array"] = taken_scheduled["taken_status_array"].slice().reverse();
            pto[tmp]["taken_total_num"] = (taken_scheduled["taken_total_num"].toFixed(1));
            pto[tmp]["taken_dates_array"] = taken_scheduled["taken_dates_array"].slice().reverse();
            pto[tmp]["taken_full_partial_array"] = taken_scheduled["taken_full_partial_array"].slice().reverse();

            pto[tmp]["scheduled_info_array"] = taken_scheduled["scheduled_info_array"].slice().reverse();
            pto[tmp]["scheduled_status_array"] = taken_scheduled["scheduled_status_array"].slice().reverse();
            pto[tmp]["scheduled_total_num"] = taken_scheduled["scheduled_total_num"].toFixed(1);
            pto[tmp]["scheduled_dates_array"] = taken_scheduled["scheduled_dates_array"].slice().reverse();
            pto[tmp]["scheduled_full_partial_array"] = taken_scheduled["scheduled_full_partial_array"].slice().reverse();
            pto[tmp]["scheduled_ids"] = taken_scheduled["scheduled_ids"].slice().reverse();

            //        pto[tmp]["scheduled"] = taken_scheduled["scheduled"];
            //        pto[tmp]["scheduled_total"] = taken_scheduled["scheduled_total"];
            //        pto[tmp]["scheduled_array"] = taken_scheduled["scheduled_array"];
            //        pto[tmp]["scheduled_full_partial"] = taken_scheduled["scheduled_full_partial"];

            pto[tmp]["remain_total"] = (pto[tmp]["limit"] + pto[tmp]["carr_over"] - pto[tmp]["taken_total_num"] - pto[tmp]["scheduled_total_num"]).toFixed(1);

        }

        // Denied and Disputed
        var tmp_denied_info_array = [];
        for (var x = 0; x < saas_data['denied'].length; x++) {
            if (saas_data['denied'][x]['date_denied'] && saas_data['denied'][x]['reason']) {
                tmp_denied_info_array.push({
                    date: saas_data['denied'][x]['date_denied'],
                    reason: this.saas_decode(saas_data['denied'][x]['reason'])
                });
            }
        }

        if (tmp_denied_info_array.length > 0) {
            pto['denied_info_array'] = tmp_denied_info_array.slice().reverse();
        }

        var tmp_disputed_info_array = [];
        for (var y = 0; y < saas_data['disputed'].length; y++) {
            if (saas_data['disputed'][y]['date_disputed'] && saas_data['disputed'][y]['reason']) {
                tmp_disputed_info_array.push({
                    date: saas_data['disputed'][y]['date_disputed'],
                    reason: this.saas_decode(saas_data['disputed'][y]['reason'])
                });
            }
        }
        if (tmp_disputed_info_array.length > 0) {
            pto['disputed_info_array'] = tmp_disputed_info_array.slice().reverse();
        }

        //window.console.log(pto);
        return pto;
    }, */

    fy_formatEmpPto(saas_data, pto, pto_cat_codes, pto_cat_names, pto_cat_plurals, fiscal_yr) {

        var tmp = "";
        var taken_scheduled = [];
        var prefix = "";
        let cur_fiscal_year = this.get_fiscal_year("cur_long");
        let next_fiscal_year = this.get_fiscal_year("next_long");
        //let prev_fiscal_year = this.get_fiscal_year("prev_long");
        let site_status = this.get_site_status();
        var zero_out_co = false;  
        // do not show carried over before data roll
        if (fiscal_yr == next_fiscal_year && site_status == "cur_and_next_year")
            zero_out_co = true;
        else if (site_status == "prev_and_cur_year" || site_status == "roll_data")  {
            // before data roll, do not show carried over for current year
            if (fiscal_yr == cur_fiscal_year)
                zero_out_co = true;
        }  
          
        //window.console.log("site_status = " + site_status + ", fy = " + fiscal_yr + ", zero_out = " + zero_out_co );    
        
        if (saas_data['lastname'].toUpperCase() == "SHING" || saas_data['lastname'].toUpperCase() == "IAFRATE" || 
            (saas_data['lastname'].toUpperCase() == "HAYES" && saas_data['firstname'].toUpperCase() == "JONI")) {
            pto[fiscal_yr]['lastname'] = this.maskEmpName(saas_data['lastname']);
            pto[fiscal_yr]['firstname'] = this.maskEmpName(saas_data['firstname']);    
        } else {
            pto[fiscal_yr]['lastname'] = saas_data['lastname'];
            pto[fiscal_yr]['firstname'] =saas_data['firstname'];
        }

        pto[fiscal_yr]['gender'] =saas_data['gender'];

        for (var i = 0; i < pto_cat_codes.length; i++) {
            tmp = pto_cat_codes[i];

            if (typeof saas_data[tmp] == 'undefined')
                continue;

            if (
                tmp == "vacation" ||
                tmp == "sick" ||
                tmp == "personal" ||
                tmp == "holiday"
            ) {
                prefix = tmp;
                if (tmp == "vacation") prefix = "vac";
                else if (tmp == "personal") prefix = "per";
                else if (tmp == "holiday") prefix = "hol";
                pto[fiscal_yr][tmp]["limit"] = this.formatNum(saas_data[prefix + "_limit"]);
                pto[fiscal_yr][tmp]["remain"] = this.formatNum(saas_data[prefix + "_rem"]);
                if (zero_out_co) {
                    pto[fiscal_yr][tmp]["accrued"] = 0;
                    pto[fiscal_yr][tmp]["carr_over"] = 0;
                    pto[fiscal_yr][tmp]["carr_over_remain"] = 0;
                } else {
                    pto[fiscal_yr][tmp]["accrued"] = this.formatNum(saas_data[prefix + "_accrued"]);
                    pto[fiscal_yr][tmp]["carr_over"] = this.formatNum(saas_data[prefix + "_co"]);
                    pto[fiscal_yr][tmp]["carr_over_remain"] = this.formatNum(saas_data[prefix + "_co_rem"]);
                }
    /*        } else if (saas_data[tmp][0]['date_requested'].length <= 0) {
                // If cat is special categories (jury duty, bereavement, etc..)
                // and has no value in date_requested, don't show category at all.
                continue; */
            } else { 
                // special categories has taken or requested dates
                if (tmp == "prenatal") {
                    pto[fiscal_yr][tmp]["limit"] = this.formatNum(saas_data["prenatal_limit"]);
                    pto[fiscal_yr][tmp]["remain"] = this.formatNum(saas_data["prenatal_rem"]);
                    pto[fiscal_yr][tmp]["carr_over"] = 0;
                } else {
                    pto[fiscal_yr][tmp]["limit"] = pto_func.get_defaultRemaining(tmp);
                    pto[fiscal_yr][tmp]["carr_over"] = 0;
                }
                /*
                if (tmp == "jury_duty")
                    pto[tmp]["limit"] = 10;
                else if (tmp == "bereavement")
                    pto[tmp]["limit"] = 10;
                else if (tmp == "covid")
                    pto[tmp]["limit"] = 1;
                else
                    pto[tmp]["limit"] = 0;
                */
            }
            pto[fiscal_yr][tmp]["name"] = pto_cat_names[i];
            pto[fiscal_yr][tmp]["name_plural"] = pto_cat_plurals[i];
            pto[fiscal_yr][tmp]["name_code"] = pto_cat_codes[i];
            pto[fiscal_yr][tmp]["requested"] = saas_data[tmp];

            taken_scheduled = this.taken_scheduled_dates(pto[fiscal_yr][tmp]["requested"], tmp, pto[fiscal_yr][tmp]["name_code"]);

            // SAAS data is in ascending order. Reverse to descending order
            pto[fiscal_yr][tmp]["taken_info_array"] = taken_scheduled["taken_info_array"].slice().reverse();
            pto[fiscal_yr][tmp]["taken_status_array"] = taken_scheduled["taken_status_array"].slice().reverse();
            pto[fiscal_yr][tmp]["taken_total_num"] = (taken_scheduled["taken_total_num"].toFixed(1));
            pto[fiscal_yr][tmp]["taken_dates_array"] = taken_scheduled["taken_dates_array"].slice().reverse();
            pto[fiscal_yr][tmp]["taken_full_partial_array"] = taken_scheduled["taken_full_partial_array"].slice().reverse();

            pto[fiscal_yr][tmp]["scheduled_info_array"] = taken_scheduled["scheduled_info_array"].slice().reverse();
            pto[fiscal_yr][tmp]["scheduled_status_array"] = taken_scheduled["scheduled_status_array"].slice().reverse();
            pto[fiscal_yr][tmp]["scheduled_total_num"] = taken_scheduled["scheduled_total_num"].toFixed(1);
            pto[fiscal_yr][tmp]["scheduled_total_leave_of_absence_num"] = taken_scheduled["scheduled_total_leave_of_absence_num"].toFixed(1);
            pto[fiscal_yr][tmp]["scheduled_dates_array"] = taken_scheduled["scheduled_dates_array"].slice().reverse();
            pto[fiscal_yr][tmp]["scheduled_full_partial_array"] = taken_scheduled["scheduled_full_partial_array"].slice().reverse();
            pto[fiscal_yr][tmp]["scheduled_ids"] = taken_scheduled["scheduled_ids"].slice().reverse();

            pto[fiscal_yr][tmp]["remain_total"] = (pto[fiscal_yr][tmp]["limit"] + pto[fiscal_yr][tmp]["carr_over"] - pto[fiscal_yr][tmp]["taken_total_num"] - pto[fiscal_yr][tmp]["scheduled_total_num"]).toFixed(1);

        }

        // Denied and Disputed
        var tmp_denied_info_array = [];
        for (var x = 0; x < saas_data['denied'].length; x++) {
            if (saas_data['denied'][x]['date_denied'] && saas_data['denied'][x]['reason']) {
                tmp_denied_info_array.push({
                    date: saas_data['denied'][x]['date_denied'],
                    reason: this.saas_decode(saas_data['denied'][x]['reason'])
                });
            }
        }

        if (tmp_denied_info_array.length > 0) {
            pto[fiscal_yr]['denied_info_array'] = tmp_denied_info_array.slice().reverse();
        }

        var tmp_disputed_info_array = [];
        for (var y = 0; y < saas_data['disputed'].length; y++) {
            if (saas_data['disputed'][y]['date_disputed'] && saas_data['disputed'][y]['reason']) {
                tmp_disputed_info_array.push({
                    date: saas_data['disputed'][y]['date_disputed'],
                    reason: this.saas_decode(saas_data['disputed'][y]['reason'])
                });
            }
        }
        if (tmp_disputed_info_array.length > 0) {
            pto[fiscal_yr]['disputed_info_array'] = tmp_disputed_info_array.slice().reverse();
        }

        return pto;

    },

    pto_set_format(){
        var cur_yr = this.get_fiscal_year("cur_long");
        var next_yr = this.get_fiscal_year("next_long");
        var prev_yr = this.get_fiscal_year("prev_long");
        var res = {};
        res[cur_yr] = this.pto_set_props();
        res[next_yr] = this.pto_set_props();
        res[prev_yr] = this.pto_set_props();
        return res;
    },


    pto_set_props() {        
        return {
            vacation: { 
                name: "",
                name_plural: "",
                name_code: "",
                limit: 0,
                remain: 0,
                accrued: 0,
                carr_over: 0,
                carr_over_remain: 0,
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
                requested: [],
              },
              sick: {
                name: "",
                name_plural: "",
                name_code: "",
                limit: 0,
                remain: 0,
                accrued: 0,
                carr_over: 0,
                carr_over_remain: 0,
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
                requested: [],
              },
              holiday: {
                name: "",
                name_plural: "",
                name_code: "",
                limit: 0,
                remain: 0,
                accrued: 0,
                carr_over: 0,
                carr_over_remain: 0,
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
                requested: [],
              },
              personal: {
                name: "",
                name_plural: "",
                name_code: "",
                limit: 0,
                remain: 0,
                accrued: 0,
                carr_over: 0,
                carr_over_remain: 0,
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
                requested: [],
              },
              bereavement: {
                name: "",
                name_plural: "",
                name_code: "",
                requested: [],
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
              },
              jury_duty: {
                name: "",
                name_plural: "",
                name_code: "",
                requested: [],
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
              },    
              prenatal: {
                name: "",
                name_plural: "",
                name_code: "",
                requested: [],
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 20,
              },
              covid: {
                name: "",
                name_plural: "",
                name_code: "",
                requested: [],
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
              },
              covid_sick: {
                name: "",
                name_plural: "",
                name_code: "",
                requested: [],
                taken_dates_str: "",
                taken_total_str: "",
                taken_total_num: 0,
                taken_dates_array: [],
                taken_full_partial_array: [],
                scheduled_dates_str: [],
                scheduled_total_str: [],
                scheduled_total_num: [],
                scheduled_total_leave_of_absence_num: [],
                scheduled_dates_array: [],
                scheduled_full_partial_array: [],
                scheduled_ids: [],
                remain_total: 0,
              },      
        };
  
      }, 

    pto_container_set_format(){
        var cur_yr = this.get_fiscal_year("cur_long");
        var next_yr = this.get_fiscal_year("next_long");
        var prev_yr = this.get_fiscal_year("prev_long");
        var res = {};
        res[cur_yr] = this.pto_container_set_props();
        res[next_yr] = this.pto_container_set_props();
        res[prev_yr] = this.pto_container_set_props();
        return res;
    }, 
    
    pto_container_set_props() {        
        return {
            vacation: [],
            holiday: [],
            personal: [],
            jury_duty: [],
            sick: [],
            bereavement: [],
            prenatal: [],
            covid: [],
            covid_sick: [],
        };
    },     
  
    sched_pto_set_format() {
        var cur_yr = this.get_fiscal_year("cur_long");
        var next_yr = this.get_fiscal_year("next_long");
        var prev_yr = this.get_fiscal_year("prev_long");

        var res = {};
        res[cur_yr] = [];
        res[next_yr] = [];
        res[prev_yr] = [];

        res[cur_yr]['fy_str'] = this.get_fiscal_year("cur_str");
        res[cur_yr]['header_id'] = "header_" + cur_yr;
        res[cur_yr]['show_fy_header'] = false;

        if (this.get_site_status() == "cur_and_next_year") {
            res[next_yr]['fy_str'] = this.get_fiscal_year("next_str");
            res[next_yr]['header_id'] = "header_" + next_yr;
            res[next_yr]['show_fy_header'] = false;
        } else {
            res[next_yr]['fy_str'] = null;
            res[next_yr]['header_id'] = null;
            res[next_yr]['show_fy_header'] = false;
        }
        
        //if (this.get_site_status() == "prev_and_cur_year" || this.get_site_status() == "roll_data" || this.get_site_status == "after_data_rolled") {
        if (this.show_prev_balance()) {    
            res[prev_yr]['fy_str'] = this.get_fiscal_year("prev_str");
            res[prev_yr]['header_id'] = "header_" + prev_yr;
            res[prev_yr]['show_fy_header'] = false;
        } else {
            res[prev_yr]['fy_str'] = null;
            res[prev_yr]['header_id'] = null;
            res[prev_yr]['show_fy_header'] = false;
        }

        return res; 
    },

    taken_scheduled_dates(requested, tmp, cat_code) {

        var res = [];
        var taken = [];
        var scheduled = [];
        var taken_array = [];
        var scheduled_array = [];
        var taken_full_partial = [];
        var scheduled_full_partial = [];
        var taken_start_time = [];
        var scheduled_start_time = [];
        var taken_end_time = [];
        var scheduled_end_time = [];
        var taken_ids = [];
        var scheduled_ids = [];
        var taken_total = 0;
        var scheduled_total = 0;
        var scheduled_total_leave_of_absence  = 0 ;
        var taken_status_array = [];
        var scheduled_status_array = [];
        var tmp_date;
        var increment = 0.5;
        var today = this.get_today_date();
        var tmp_status ;
        

        for (var i = 0; i < requested.length; i++) {

            tmp_status = "" ;

            if (requested[i]['date_requested'].length <= 0)
                continue;

            tmp_date = new Date(this.formatSaasDate(requested[i]['date_requested']) + "T09:00:00.000Z");

            if (cat_code == "prenatal") {
                let prenatal_start = moment(requested[i]['start'], ['h:m a', 'H:m']) ;
                let prenatal_end = moment(requested[i]['end'], ['h:m a', 'H:m']) ;
                increment = this.calculateHoursBetween(prenatal_start, prenatal_end) ; 
            } else {
                increment = this.full_partial_to_num(requested[i]['type']);
            }

            if (tmp_date.getTime() < today.getTime()) {
                if (cat_code == "prenatal") {
                    taken.push(this.formatDate(tmp_date, "long") + " - " + moment(requested[i]['start'], ['h:m a', 'HH:mm', 'HH:mm:ss']).format("hh:mm a") + " - " + moment(requested[i]['end'], ['h:m a', 'HH:mm', 'HH:mm:ss']).format("hh:mm a"));
                    taken_full_partial.push("");
                    taken_ids.push(tmp + "_" + requested[i]['date_requested'] + "_" + requested[i]['start'].replace(" ", ".") + "-" + requested[i]['end'].replace(" ", "."));
                    taken_start_time.push(requested[i]['start']);
                    taken_end_time.push(requested[i]['end'])
                } else {
                    taken.push(this.formatDate(tmp_date, "long") + " - " + this.formatDayType(requested[i]['type'], true));
                    taken_full_partial.push(requested[i]['type']);
                    taken_ids.push(tmp + "_" + requested[i]['date_requested'] + "_" + requested[i]['type']);
                    taken_start_time.push("");
                    taken_end_time.push("")
                }
                
                taken_total += increment;
                taken_array.push(requested[i]['date_requested']);
                taken_status_array.push(this.get_pto_status(cat_code, requested[i]['confirmed'],requested[i]['approved_by']));
/*
                if (requested[i]['confirmed'].includes("/"))
                    taken_status_array.push("Confirmed");
                else if (requested[i]['approved_by'].includes("/"))
                    taken_status_array.push("Approved");
                else
                    taken_status_array.push("Pending");
*/                    
            } else {

                tmp_status = this.get_pto_status(cat_code, requested[i]['confirmed'],requested[i]['approved_by']) ;

                if (cat_code == "prenatal") {
                    scheduled.push(this.formatDate(tmp_date, "long") + " - " + moment(requested[i]['start'], ['h:m a', 'HH:mm', 'HH:mm:ss']).format("hh:mm a") + " - " + moment(requested[i]['end'], ['h:m a', 'HH:mm', 'HH:mm:ss']).format("hh:mm a"));
                    scheduled_full_partial.push("");
                    // format: prenatal_01/01/2025_08:00.am-09:00.am 
                    scheduled_ids.push(tmp + "_" + requested[i]['date_requested'] + "_" + requested[i]['start'].replace(" ", ".") + "-" + requested[i]['end'].replace(" ", "."));
                    scheduled_start_time.push(requested[i]['start']) ;
                    scheduled_end_time.push(requested[i]['end']) ;
                } else {
                    scheduled.push(this.formatDate(tmp_date, "long") + " - " + this.formatDayType(requested[i]['type'], true));
                    scheduled_full_partial.push(requested[i]['type'] );
                    scheduled_ids.push(tmp + "_" + requested[i]['date_requested'] + "_" + requested[i]['type'].trim());
                    scheduled_start_time.push("") ;
                    scheduled_end_time.push("") ;
                }

                scheduled_total += increment;
                scheduled_array.push(requested[i]['date_requested']);
                scheduled_status_array.push(tmp_status);

                if (tmp_status.toLowerCase() == "confirmed") {
                    scheduled_total_leave_of_absence += increment ;
                }
/*
                if (requested[i]['confirmed'].includes("/"))
                    scheduled_status_array.push("Confirmed");
                else if (requested[i]['approved_by'].includes("/"))
                    scheduled_status_array.push("Approved");
                else
                    scheduled_status_array.push("Pending");
                */
            }
        }

        if (taken.length > 0) { // normal display
            res["taken_info_array"] = taken;
            res["taken_total_num"] = taken_total;
            res["taken_dates_array"] = taken_array;
            res["taken_full_partial_array"] = taken_full_partial;
            res["taken_status_array"] = taken_status_array;
        } else {
            res["taken_info_array"] = [];
            res["taken_total_num"] = 0;
            res["taken_dates_array"] = [];
            res["taken_full_partial_array"] = [];
            res["taken_status_array"] = [];
        }

        if (scheduled.length > 0) {
            res["scheduled_info_array"] = scheduled;
            res["scheduled_total_num"] = scheduled_total;
            res["scheduled_total_leave_of_absence_num"] = scheduled_total_leave_of_absence ;
            res["scheduled_dates_array"] = scheduled_array;
            res["scheduled_full_partial_array"] = scheduled_full_partial;
            res["scheduled_ids"] = scheduled_ids;
            res["scheduled_status_array"] = scheduled_status_array;
        } else {
            res["scheduled_info_array"] = [];
            res["scheduled_total_num"] = 0;
            res["scheduled_total_leave_of_absence_num"] = 0 ; 
            res["scheduled_dates_array"] = [];
            res["scheduled_full_partial_array"] = [];
            res["scheduled_ids"] = [];
            res["scheduled_status_array"] = [];
        }

        return res;

    },


    get_pto_status(cat_code, cfm_date_str, apv_by_str) {

        // do not required approval and confirmation
        if (cat_code == "bereavement" || cat_code == "jury_duty" || cat_code == "covid" || cat_code == "covid_sick" || cat_code == "prenatal")
            return "";

        if (cfm_date_str && cfm_date_str.includes("/")) {
            return "Confirmed";
        //} else if (apv_by_str) {
        } else if (apv_by_str && apv_by_str.replace(",","").length > 0) {
            return "Approved";
        } else {
            return "Pending";
        }
    },


    get_cfm_status(type, pending_confirmed) {
        /*pending confirmed value:
        0 = no pendings
        1 = past months pending
        2 = this month pending
        3 = prior months AND this month pending
        */

        let site_status = this.get_site_status();

        const today = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
        const today_month = new Date(today).getMonth() + 1; // getMonth() returns 0–11

        const today2 = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
        today2.setHours(0, 0, 0, 0);
        const confirmSeptPTOStart = new Date(today2.getFullYear(), 8, 15, 0, 0, 0, 0); // After Sept 15, users can confirm current month
        
        const isAfterSeptConfirmStart = today2 > confirmSeptPTOStart;
    
        if (type == "this_month") {
            // For the View/Confirm button for current month
            // Before data roll, do not confirm September pto
            if (site_status == "prev_and_cur_year")
                return false;
            else if (site_status == "cur_year_only" && today_month == 9 && isAfterSeptConfirmStart == false)
                return false;
            else if (pending_confirmed == 0 || pending_confirmed == 1)
                return false;
            else
                return true;
        }
   
        if (type == "prev") {
            // roll_data and after_data_rolled do not need to confirm prev pto
            if (site_status == "roll_data" || site_status == "after_data_rolled") {
                // not being used anymore
                return false;
            } else if (site_status == "cur_year_only" && today_month == 9 && (pending_confirmed == 1 || pending_confirmed == 3)) {
                /****** 
	            In September, if site_status is "cur_year_only", it means the previous fiscal year's data has likely been rolled or is about to be. In this case, users don’t need to confirm last FY’s PTO anymore.
	            However, if pending_confirmed is 1 or 3 (has prev unconfirmed pto), the data roll is probably incomplete and SAAS may still be sending last FY’s data.
	            So, return has_unconfirmed_pto = false to prevent the frontend from forcing users to confirm August PTO.
	            ********/
                return false;
            } else if (pending_confirmed == 0 || pending_confirmed == 2) {
                return false;
            } else {
                return true;
            }
        }

    },

    get_badge_status(type, pending_confirmed, pending_mgr_approval) {

        if (type == "balance") {
            if (this.get_cfm_status("this_month", pending_confirmed) == true || this.get_cfm_status("prev", pending_confirmed) == true)
                return true;
            else
                return false;
        } else if (type == "pto") {
            if (this.get_cfm_status("this_month", pending_confirmed) == true || this.get_cfm_status("prev", pending_confirmed) == true)
                return true;
            if (pending_mgr_approval == "Y")
                return true;
        }

        return false;

    },


    show_prev_balance() {

        let site_status = this.get_site_status();

        if (site_status == "prev_and_cur_year" || site_status == "roll_data" || site_status == "after_data_rolled")
            return true;

        return false;

    },


    formatDate(dateObj, format = null) {
        if (format == "long")
            return dateObj.toLocaleString('en-us', { month: 'long', year: 'numeric', day: 'numeric', timeZone: 'UTC' });
        else
            return dateObj.toISOString().slice(0, 10);
    },


    formatDayType(day_type, return_blank = false) {
        if (this.is_NYPFL(day_type)) { 
            if (return_blank)
                return "";
            else
                return 0.3 ;
        } else {
            return day_type;
        }
    },

    full_partial_to_num(day_type) {
        var res = 0.5;
        if (this.is_NYPFL(day_type)) 
            res = 0.3;
        else if (day_type.toUpperCase() == "FULL")
            res = 1;
        
        return res;
    },

    
    calculateHoursBetween(start_time, end_time) {
        return end_time.diff(start_time, 'hours', true);
    },


    is_NYPFL(day_type) {
        day_type = String(day_type) ;
        var saasNYPFL = ["3", "0.3", "0.33", "0.30", "0.34"] ; 
        if (saasNYPFL.includes(day_type)) 
            return true;
        else
            return false;
    },


    is_sched_DIS(saved_day_type, saved_status) {
        // Because SAAS data doesn't indicate if a past pto is DIS or not (majority of past ptos have status = confirmed), 
        // we can only check if a scheduled pto is DIS or not.
        // Future DIS has full_partial = "AM" and status = "Confirmed" with a confirmed date
        saved_day_type = String(saved_day_type) ;
        if ((saved_day_type).toLowerCase() == "am" && saved_status.toLowerCase() == "confirmed") 
            return true;
        else
            return false;
    },


    getCompDays(type) {
        
        var names = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
        var codes = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"];

        switch (type) {
            case "names":
                return names;
            case "object":
                var res = [];
                for (var i = 0; i < codes.length; i++) {
                    res.push({ id: codes[i], name: names[i] });
                }
                return res;
            default:
                return codes;
        }
    },



    maskEmpName(name) {
        var do_trainings = false;   // set to false when no need to do trainings

        if (do_trainings == false) {
            return name;   
        } else {        
            // hide real name for training purposes
            var tmp = name.split(" ");
            var res = "";
            var delimiter = "";
            for (var i = 0; i < tmp.length; i++) {
                if (tmp[i].charAt(tmp[i].length - 1) == ",") {
                    delimiter = ", ";
                } else {
                    delimiter = " ";
                }
                for (var j = 0; j < tmp[i].length; j++) {
                    if (j < 1) 
                        res += tmp[i][j];
                    else
                        res += "*"; 
                }
                res += delimiter ;
            }
            //var res = name.charAt(0) + "xxxxx";
            return res; 
        }
    },

    formatSaasDate(saas_date) {
        var tmp = saas_date.split("/");
        return tmp[2] + "-" + tmp[0] + "-" + tmp[1]
    },
    
    saas_decode(text) {

        var saasLineBreak = "__LINEBREAK__";
        var saasAmp = "__AMP__";
        var saasEqual = "__EQUAL__";
        var saasApos = "_APOS_"; // as requested by saas, passing 1 underscore
        var saasBackslash = "__BACKSLASH__";
        var saasPipe = "__PIPE__";

        var res = text;
        res = res.replaceAll(saasLineBreak, "\\n");
        res = res.replaceAll(saasAmp, "&");
        res = res.replaceAll(saasEqual, "=");
        res = res.replaceAll(saasApos, "'");
        res = res.replaceAll(saasPipe, "|");
        res = res.replaceAll("\\\"", "'");
        res = res.replaceAll(saasBackslash, "\\\\");
        return res;
    },

    debug () {
        return false;
        //return true;
    },

    debug_fy_start_month () {
        return 9;
    }

}

export default pto_func